import {
  As,
  Button,
  Circle,
  Heading,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";

import React from "react";

const EmptyState: React.FC<{
  icon?: {
    color: string;
    icon: As;
  };
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
    isDisabled?: boolean;
    colorScheme?: string;
  };
  size?: "sm" | "md" | "lg";
  bgColor?: string;
}> = ({ icon, title, description, action, size = "md", bgColor }) => {
  return (
    <VStack
      w={"full"}
      justifyContent="center"
      alignItems="center"
      spacing={{
        base: size === "sm" ? 2 : size === "md" ? 4 : 8,
        md: size === "sm" ? 4 : size === "md" ? 8 : 16,
      }}
      p={{
        base: size === "sm" ? 4 : size === "md" ? 8 : 12,
        md: size === "sm" ? 8 : size === "md" ? 12 : 16,
      }}
      bgColor={bgColor}
      borderRadius={"xl"}
    >
      {icon && (
        <Circle bgColor={`${icon.color}.50`} p={6}>
          <Icon as={icon.icon} boxSize={10} color={`${icon.color}.500`} />
        </Circle>
      )}

      <VStack
        justifyContent="center"
        alignItems="center"
        spacing={{
          base: size === "sm" ? 1 : size === "md" ? 2 : 6,
          md: size === "sm" ? 2 : size === "md" ? 4 : 8,
        }}
        textAlign={"center"}
      >
        <Heading size="lg">{title}</Heading>
        <Text>{description}</Text>
        {action && (
          <Button
            colorScheme={action.colorScheme || "primary"}
            mt={2}
            onClick={action.onClick}
            isDisabled={action.isDisabled}
          >
            {action?.label}
          </Button>
        )}
      </VStack>
    </VStack>
  );
};

export default EmptyState;
